/**
 * Environment Configuration (Fail Fast Strategy)
 * 
 * Centralizes all access to import.meta.env.
 * Throws errors immediately if critical variables are missing in production.
 */

const getEnvParam = (key: string, required: boolean = false): string => {
    const value = import.meta.env[key];

    if (required && !value) {
        // En desarrollo permitimos valores vacíos para simulación, pero en prod es fatal
        if (import.meta.env.PROD) {
            throw new Error(`🔥 CRITICAL CONFIG ERROR: Missing environment variable ${key}`);
        } else {
            console.warn(`⚠️ Missing dev config: ${key}`);
        }
    }
    return value || '';
};

export const env = {
    // Core
    IS_DEV: import.meta.env.DEV,
    IS_PROD: import.meta.env.PROD,
    MODE: import.meta.env.MODE,

    // API
    API_URL: getEnvParam('VITE_API_URL', false) || '/api/v1', // Default to versioned API prefix

    // Features
    ENABLE_MOCK: import.meta.env.VITE_ENABLE_MOCK === 'true',

    // External Services (Add as needed)
    GOOGLE_MAPS_KEY: getEnvParam('VITE_GOOGLE_MAPS_KEY', false),
    GOOGLE_CLIENT_ID: getEnvParam('VITE_GOOGLE_CLIENT_ID', false) || 'MOCK_CLIENT_ID', // Fail safe for dev

    // Supabase
    SUPABASE_URL: getEnvParam('VITE_SUPABASE_URL', false),
    SUPABASE_ANON_KEY: getEnvParam('VITE_SUPABASE_ANON_KEY', false),
};

// Log startup config (sanitized)
console.info('🚀 App Config Loaded:', {
    env: env.MODE,
    api: env.API_URL,
    mock: env.ENABLE_MOCK
});
